import { parse, isValid } from 'date-fns';

const loaded = {};

const parseBuildTimestamp = dateString => {
  if (!dateString) return dateString;
  const parsed = parse(dateString, 'yyyy.M.d-Hmmss', new Date());
  if (!isValid(parsed)) return dateString;
  return new Date(parsed.getTime() - parsed.getTimezoneOffset() * 60000);
};

/**
 * Logs the running bundle's build metadata once per app key (NG / AI / OLD / BASE).
 * common-utils is bundled per federation (not a MF singleton), so process.env.BUILD_*
 * resolves to the consuming app's build-time values. `loaded` dedups repeated calls
 * (e.g. from several federated bridges of the same app) so it prints only once — keyed by
 * app + BUILD_TIMESTAMP so a busted remoteEntry cache (new build, same app key) logs again.
 */
export const logBuildInfo = app => {
  const key = `${app}:${process.env.BUILD_TIMESTAMP}`;
  if (loaded[key]) return;
  loaded[key] = true;
  const commit = process.env.GIT_COMMIT || '';
  const shortCommit = commit.length > 16 ? `${commit.slice(0, 8)}...${commit.slice(-8)}` : commit;
  // eslint-disable-next-line no-console
  console.log(
    `${app} Build Timestamp`,
    parseBuildTimestamp(process.env.BUILD_TIMESTAMP),
    `(${process.env.BUILD_TIMESTAMP})`,
    'Branch',
    process.env.BUILD_BRANCH,
    'Commit',
    shortCommit,
    '#',
    process.env.BUILD_NUMBER
  );
};
